package org.maplibre.compose.demoapp.demos

internal actual fun earthquakeHexbins(): EarthquakeHexbins? = null
